export const PLAYGROUND_CONSTANTS = {
  HEADER_HEIGHT: 56,
  SETTINGS_PANEL_MAX_WIDTH: 480,
  VIDEO_RESOLUTION: 'h720' as const,
} as const

export const LIVEKIT_OPTIONS = {
  AUDIO_BITRATE: 24_000,
  ECHO_CANCELLATION: true,
  NOISE_SUPPRESSION: true,
  DTX: true,
  RED: true,
} as const
